import * as React from 'react';

import { LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED } from '../../../../../../shared/common/hooks/useUxFbPoll/constants';
import {
  getLocalStorageFiltersWereAppliedTwoTimes,
  setLocalStorageFiltersApplied,
} from '../../../../../../shared/common/hooks/useUxFbPoll/localStorageUtils';
import { FOfferType } from '../../../../../JsonQuery';
import { OfferType } from '../../../components/filters/OfferType';
import { useDealType } from '../../../utils/useDealType';
import { useFiltersContext } from '../../../utils/useFiltersContext';
import { useOfferType } from '../../../utils/useOfferType';

export const OfferTypeContainer: React.FC = () => {
  const { onChange, onApply } = useFiltersContext();
  const dealType = useDealType();
  const offerType = useOfferType();

  const isLocalStorageFiltersWereAppliedTwoTimes = getLocalStorageFiltersWereAppliedTwoTimes(
    LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED,
  );

  const handleChange = React.useCallback(
    (offerType: FOfferType) => {
      onChange({ action: 'setOfferType', arguments: [offerType] });
      onApply();

      //Если фильтр был применен 2 раза, сохраняем значеине в LocalStorage
      if (!isLocalStorageFiltersWereAppliedTwoTimes) {
        setLocalStorageFiltersApplied(LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED);
      }
    },
    [onChange, onApply, isLocalStorageFiltersWereAppliedTwoTimes, setLocalStorageFiltersApplied],
  );

  return <OfferType dealType={dealType} value={offerType} onChange={handleChange} />;
};
